// frontend/src/pages/student/GroupChatPage.js (نسخه اصلاح شده)

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom'; // ✅ useNavigate ایمپورت شد
import axiosInstance from '../../modules/api';
import StudentHeader from '../../components/layout/StudentHeader';
import { FaUsers, FaSpinner, FaArrowLeft, FaPaperPlane } from 'react-icons/fa';

// (کامپوننت Avatar بدون تغییر)
const Avatar = ({ user }) => {
    const name = user?.full_name || user?.username || "؟";
    const initial = name.charAt(0);
    return <div className="avatar">{initial}</div>;
};

// (کامپوننت ChatMessage بدون تغییر)
const ChatMessage = ({ message, isMe }) => (
    <div className={`chat-message ${isMe ? 'me' : 'other'}`}>
        {!isMe && (
            <div className="chat-avatar">
                <Avatar user={message.author} />
            </div>
        )}
        <div className="chat-bubble">
            {!isMe && (
                <strong className="chat-author-name">
                    {message.author?.full_name || message.author?.username}
                </strong>
            )}
            <p className="chat-content">{message.content}</p>
            <span className="chat-timestamp">
                {new Date(message.created_at).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })}
            </span>
        </div>
    </div>
);


const GroupChatPage = () => {
    const { groupId } = useParams();
    const navigate = useNavigate(); // ✅ هوک navigate
    const [messages, setMessages] = useState([]);
    const [groupName, setGroupName] = useState("...");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [newMessage, setNewMessage] = useState("");
    const [sending, setSending] = useState(false);
    
    const messagesEndRef = useRef(null); 
    const currentUsername = localStorage.getItem('userName'); 
    
    // ✅✅✅ تشخیص نقش کاربر
    const userRole = localStorage.getItem('userRole');
    const isStudent = userRole === 'Student';

    // (تابع fetchMessages بدون تغییر)
    const fetchMessages = useCallback(async () => {
        // (اگر اولین بار است لود می‌شود، اسپینر نشان بده)
        if (messages.length === 0) setLoading(true); 
        
        try {
            const response = await axiosInstance.get(`/core/groups/${groupId}/chat/`);
            setMessages(response.data); 
            // TODO: نام گروه باید از API جزئیات گروه گرفته شود
        } catch (err) {
            console.error("Error fetching messages:", err);
            setError(err.response?.data?.detail || "خطا در بارگذاری پیام‌ها. شما عضو این گروه نیستید.");
        } finally {
            setLoading(false);
        }
    }, [groupId, messages.length]); // messages.length برای جلوگیری از لودینگ در پولینگ

    // (useEffect پولینگ بدون تغییر)
    useEffect(() => {
        fetchMessages(); 
        const interval = setInterval(() => {
            fetchMessages();
        }, 5000); 
        return () => clearInterval(interval);
    }, [fetchMessages]);

    // (useEffect اسکرول بدون تغییر)
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    // (تابع handleSendMessage بدون تغییر)
    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!newMessage.trim() || sending) return;

        setSending(true);
        try {
            await axiosInstance.post(`/core/groups/${groupId}/chat/`, {
                content: newMessage
            });
            setNewMessage(""); 
            await fetchMessages(); 
        } catch (err) {
            console.error("Error sending message:", err);
            alert("خطا در ارسال پیام.");
        } finally {
            setSending(false);
        }
    };

    // (تابع renderChat بدون تغییر)
    const renderChat = () => {
        if (loading) {
            return <div className="text-center p-10"><FaSpinner className="spinner text-3xl" /></div>;
        }
        if (error) {
            return <div className="alert alert-danger m-4">{error}</div>;
        }
        if (messages.length === 0) {
            return <p className="text-center text-gray-400 p-5">هنوز پیامی در این گروه ارسال نشده است.</p>;
        }
        return messages.map(msg => (
            <ChatMessage 
                key={msg.id} 
                message={msg} 
                isMe={msg.author?.username === currentUsername} 
            />
        ));
    };

    // ✅✅✅ تابع جدید برای بازگشت (مخصوص معلم)
    const getBackLink = () => {
        if (isStudent) {
            return "/student/dashboard";
        }
        // اگر معلم باشد، باید به صفحه مدیریت گروه‌ها برگردد
        // (ما ID دوره را نداریم، پس موقتا به لیست دوره‌ها برمی‌گردیم)
        // TODO: در آینده این بخش باید هوشمندتر شود و ID دوره را نگه دارد
        return "/teacher/courses"; 
    };

    return (
        // ✅✅✅ اصلاح کلاس layout بر اساس نقش
        // اگر دانش‌آموز باشد، هدر آبی را می‌گیرد، در غیر این صورت (معلم) هیچ هدر پیش‌فرض بصری ندارد
        <div className={isStudent ? "app-layout-student" : ""}>
            {/* ✅ هدر فقط برای دانش‌آموز نمایش داده می‌شود */}
            {isStudent && <StudentHeader />}
            
            {/* ✅ ارتفاع صفحه بر اساس نقش تنظیم می‌شود */}
            <div 
                className="chat-page-container" 
                // اگر دانش‌آموز است، ارتفاع را منهای هدر تنظیم کن
                // اگر معلم است، این کامپوننت داخل AdminLayout رندر می‌شود و ارتفاع کامل می‌گیرد
                style={{ height: isStudent ? 'calc(100vh - 60px)' : 'calc(100vh - 65px)' }} // 65px ارتفاع هدر معلم
            >
                
                <div className="chat-header">
                    {/* ✅ دکمه بازگشت هوشمند */}
                    <Link 
                        to={getBackLink()}
                        className="chat-back-btn"
                    >
                        <FaArrowLeft />
                    </Link>
                    <FaUsers />
                    <h1>{groupName}</h1> 
                </div>

                <div className="chat-messages-body">
                    {renderChat()}
                    <div ref={messagesEndRef} />
                </div>

                <form className="chat-input-form" onSubmit={handleSendMessage}>
                    <input
                        type="text"
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        placeholder="پیام خود را تایپ کنید..."
                        disabled={sending || loading}
                    />
                    <button type="submit" className="button button-primary" disabled={sending || loading}>
                        {sending ? <FaSpinner className="spinner" /> : <FaPaperPlane />}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default GroupChatPage;